import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const getModule = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'module/',
    params: params,
    method: 'get'
  })
}

export const getModuleAllList = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'module_all_list/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const getModuleAllListLog = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'module_all_list_log/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const changeModule = (data, id) => {
  let url = workFlowBaseUrl + 'module/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    traditional: true,
    method: method
  })
}

export const detailModule = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'module/' + id + '/',
    method: 'get'
  })
}

export const getModuleDevelopments = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'module/' + id + '/developments',
    method: 'get'
  })
}

export const deleteModule = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'module/' + id + '/',
    method: 'delete'
  })
}

export const logicDeleteModule = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'module/' + id + '/logic_delete/',
    method: 'delete'
  })
}

export const getApprovalProcess = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'approval_process/',
    params: params,
    method: 'get'
  })
}
